__turbopack_context__.v({
  "SCheckboxSvg": "_8hF5Sa_SCheckboxSvg",
  "SEmailInput": "_8hF5Sa_SEmailInput",
  "SError": "_8hF5Sa_SError",
  "SForm": "_8hF5Sa_SForm",
  "SLabel": "_8hF5Sa_SLabel",
  "SNewsletterSignup": "_8hF5Sa_SNewsletterSignup",
  "SPersonvern": "_8hF5Sa_SPersonvern",
  "SResponse": "_8hF5Sa_SResponse",
  "SSubmitButton": "_8hF5Sa_SSubmitButton",
  "ThemeDk": "_8hF5Sa_ThemeDk",
});
